
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1jls2_66",
  "button": "awsui_button_vjswe_1jls2_70",
  "variant-normal": "awsui_variant-normal_vjswe_1jls2_131",
  "disabled": "awsui_disabled_vjswe_1jls2_152",
  "variant-primary": "awsui_variant-primary_vjswe_1jls2_160",
  "variant-link": "awsui_variant-link_vjswe_1jls2_189",
  "variant-icon": "awsui_variant-icon_vjswe_1jls2_218",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1jls2_247",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1jls2_276",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1jls2_305",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1jls2_338",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1jls2_367",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1jls2_396",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1jls2_430",
  "button-no-text": "awsui_button-no-text_vjswe_1jls2_526",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1jls2_530",
  "full-width": "awsui_full-width_vjswe_1jls2_533",
  "button-compact": "awsui_button-compact_vjswe_1jls2_550",
  "icon-left": "awsui_icon-left_vjswe_1jls2_560",
  "icon-right": "awsui_icon-right_vjswe_1jls2_565",
  "icon": "awsui_icon_vjswe_1jls2_560",
  "link": "awsui_link_vjswe_1jls2_584",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1jls2_584"
};
  